<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.employmentType')" filterable clearable
      :size="size" class="d-block">
      <el-option v-for="(employmentType,index) in employmentTypes" :key="'employmentTypes-' + index" :label="employmentType.type" :value="employmentType.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
       id:{
          default: null
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.employmentTypes && this.employmentTypes.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        employmentTypes: 'employmentType/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'employmentType/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
